import Vue from "vue";

import {
  BButton,
  BBadge,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BFormRadioGroup,
  BFormGroup,
  BFormSelect,
  BCol,
  BRow,
  BFormText,
  BForm,
  BLink,
  BModal,
  BTooltip,
  BNav,
  BProgress,
  BNavItem,
  BPagination,
  BTab,
  BTabs,
  BAlert,
  BButtonClose,
  BFormInvalidFeedback,
  BCarousel,
  BCarouselSlide,
  BSpinner,
  BCollapse,
  VBToggle,
  VBTooltip,
} from "bootstrap-vue";

Vue.component("b-button", BButton);
Vue.component("b-badge", BBadge);
Vue.component("b-col", BCol);
Vue.component("b-row", BRow);
Vue.component("b-form-text", BFormText);
Vue.component("b-form-input", BFormInput);
Vue.component("b-form-checkbox", BFormCheckbox);
Vue.component("b-form-radio-group", BFormRadioGroup);
Vue.component("b-form-group", BFormGroup);
Vue.component("b-form-textarea", BFormTextarea);
Vue.component("b-form-select", BFormSelect);
Vue.component("b-input", BFormInput);
Vue.component("b-form", BForm);
Vue.component("b-link", BLink);
Vue.component("b-modal", BModal);
Vue.component("b-tooltip", BTooltip);
Vue.component("b-nav", BNav);
Vue.component("b-progress", BProgress);
Vue.component("b-nav-item", BNavItem);
Vue.component("b-pagination", BPagination);
Vue.component("b-tab", BTab);
Vue.component("b-tabs", BTabs);
Vue.component("b-alert", BAlert);
Vue.component("b-button-close", BButtonClose);
Vue.component("b-form-invalid-feedback", BFormInvalidFeedback);
Vue.component("b-carousel", BCarousel);
Vue.component("b-carousel-slide", BCarouselSlide);
Vue.component("b-spinner", BSpinner);
Vue.component("b-collapse", BCollapse);
Vue.directive("b-toggle", VBToggle);
Vue.directive("b-tooltip", VBTooltip);
